import React from 'react';
import { useLocalization } from '../../context/Localization/localization';
import { formatAsCurrency } from '../../helpers/Number';
import { ConditionControl } from '../AccessControl/ConditionControl';
import { ButtonBase } from '@mui/material';
import css from './ServiceItemList.module.scss';
import { GMSizedIcon } from '../Icon';

export interface IServiceItemProps {
    onDelete?: () => void;
    title: string;
    details?: string;
    price?: number | JSX.Element;
    minEstCost?: number;
    comment?: string;
    partsPrice?: number;
    laborPrice?: number;
    childServices?: Array<{ description?: string; price?: number; }>;
}

export const ServiceItem = React.memo((props: IServiceItemProps) => {
    const Localization = useLocalization();

    const renderDetails = () => {
        let details: string[] = [];

        if (props.details) {
            details = props.details.split('\n');
        }

        if (details.length > 0) {
            return details.map((d, index) => <div key={`service-item-details-${index}`}>{d}</div>);
        }
        else {
            return props.details;
        }
    };

    return (
        <div>
            <div className={css.serviceItem}>
                <div>
                    <h3>{props.title}</h3>
                    <div>{props.comment}</div>
                </div>
                <div>
                    {renderDetails()}

                    {!!props.laborPrice && (
                        <div>
                            {`${Localization.LaborPrice} `}
                            <span className={css.price}>
                                {formatAsCurrency(props.laborPrice || 0, true)}
                            </span>
                        </div>
                    )}
                    {!!props.partsPrice && (
                        <div>
                            {`${Localization.PartsPrice} `}
                            <span className={css.price}>
                                {formatAsCurrency(props.partsPrice || 0, true)}
                            </span>
                        </div>
                    )}
                </div>
                <div className={css.priceContainer}>
                    <span className={css.price}>{typeof props.price === 'number' ? formatAsCurrency(props.price || 0, true) : props.price}</span>
                    <ConditionControl condition={!!props.onDelete}>
                        {() => (
                            <ButtonBase
                                onClick={props.onDelete}
                                type={'button'}
                                title={Localization.ClickToRemoveService}
                                classes={{ root: css.remove }}
                            >
                                <GMSizedIcon iconType={'Close'} ariaLabel={Localization.DeleteIcon} />
                            </ButtonBase>
                        )}
                    </ConditionControl>
                </div>
            </div>
            {!!props.childServices &&
                props.childServices.map((childService, index) => (
                    <div key={`service-item-child-service-${index}`} className={css.serviceItem}>
                        <div />

                        {childService.description}

                        <h3 className={css.priceContainer}>
                            <span className={css.price}>{formatAsCurrency(childService.price || 0, true)}</span>
                        </h3>
                    </div>
                ))}
        </div>
    );
});
